<template>
    <!-- <div class="section pt-0 mt-0">
        <div class="listed-detail mt-1 page-title">
            <h3 class="text-center mt-1 custom-title">{{ $t('meeting_report') }}</h3>
        </div>
    </div> -->

    <div class="section pt-0 mt-1">
        <div class="mr-filter-card">
            <div class="mr-filter-header">
                <ion-icon name="options-outline"></ion-icon>
                <span class="mal-text">ഫിൽട്ടർ ചെയ്യുക</span>
            </div>
            <div class="mr-filter-body">
                <div class="mr-filter-row">
                    <div class="mr-filter-field">
                        <label class="mr-filter-label mal-text" for="filter_meeting_level">മീറ്റിംഗ് ലെവൽ</label>
                        <select class="form-control custom-select" v-model="filter_meeting_level" id="filter_meeting_level">
                            <option value="">---{{ $t('select') }}---</option>
                            <option v-for="lvl in meetingLevelOptions" :key="lvl.level" :value="lvl.level">{{ lvl.label }}</option>
                        </select>
                    </div>
                </div>
                <div class="mr-filter-row">
                    <div class="mr-filter-field">
                        <label class="mr-filter-label mal-text" for="select4">{{ $t('meeting_type') }}</label>
                        <select as="select" class="form-control custom-select" v-model="filter_meeting" name="filter_type"
                            id="select4">
                            <option value>---{{ $t('select') }}---</option>
                            <option v-for="meeting in meeting_list" v-bind:value="meeting.id" v-bind:key="meeting.id">{{
                                meeting.name }}
                            </option>
                        </select>
                    </div>
                    <div class="mr-filter-field" v-if="user_level === 1">
                        <label class="mr-filter-label mal-text" for="filter_region">{{ $t('region') }}</label>
                        <select class="form-control custom-select" v-model="filter_region" name="filter_region" id="filter_region">
                            <option value="kerala">{{ $t('kerala') }}</option>
                            <option value="outside">{{ $t('out_of_kerala') }}</option>
                        </select>
                    </div>
                </div>
                <div class="mr-filter-row">
                    <div class="mr-filter-field">
                        <label class="mr-filter-label mal-text" for="filter_date_from">{{ $t('date_from') }}</label>
                        <input type="date" class="form-control" id="filter_date_from" name="filter_date_from" v-model="filter_date_from" />
                        <ErrorMessage name="date_from" class="error-feedback" />
                    </div>
                    <div class="mr-filter-field">
                        <label class="mr-filter-label mal-text" for="filter_date_to">{{ $t('date_to') }}</label>
                        <input type="date" class="form-control" id="filter_date_to" name="filter_date_to" v-model="filter_date_to" />
                        <ErrorMessage name="date_to" class="error-feedback" />
                    </div>
                </div>
                <div class="mr-filter-actions">
                    <button type="button" class="mr-btn mr-btn-ghost" @click="clearFilter()">
                        <ion-icon name="trash-bin-outline"></ion-icon>
                        <span class="mal-text">{{ $t('clear') }}</span>
                    </button>
                    <button type="button" class="mr-btn mr-btn-primary" @click="getMembersList()">
                        <ion-icon name="search-outline"></ion-icon>
                        <span class="mal-text">{{ $t('search') }}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>

    <div class="section pt-0 mt-2">
        <div class="mr-stats-grid">
            <button type="button" class="mr-stat-card mr-stat-target" :class="{ active: statusFilter === 'target' }" @click="toggleStatusFilter('target')">
                <span class="mr-stat-icon"><ion-icon name="flag-outline"></ion-icon></span>
                <span class="mr-stat-value">{{ count_target }}</span>
                <span class="mr-stat-label mal-text">{{ $t('target') }}</span>
            </button>
            <button type="button" class="mr-stat-card mr-stat-confirmed" :class="{ active: statusFilter === 'confirmed' }" @click="toggleStatusFilter('confirmed')">
                <span class="mr-stat-icon"><ion-icon name="checkmark-done-outline"></ion-icon></span>
                <span class="mr-stat-value">{{ count_confirmed }}</span>
                <span class="mr-stat-label mal-text">{{ $t('confirmed') }}</span>
            </button>
            <button type="button" class="mr-stat-card mr-stat-increase" :class="{ active: statusFilter === 'done' }" @click="toggleStatusFilter('done')">
                <span class="mr-stat-icon"><ion-icon name="trending-up-outline"></ion-icon></span>
                <span class="mr-stat-value">{{ count_total }}</span>
                <span class="mr-stat-label mal-text">{{ $t('increase') }}</span>
            </button>
            <button type="button" class="mr-stat-card mr-stat-not-scheduled" :class="{ active: statusFilter === 'not_scheduled' }" @click="toggleStatusFilter('not_scheduled')">
                <span class="mr-stat-icon"><ion-icon name="time-outline"></ion-icon></span>
                <span class="mr-stat-value">{{ notScheduledCount }}</span>
                <span class="mr-stat-label mal-text">നിശ്ചയിച്ചിട്ടില്ല</span>
            </button>
        </div>
        <p class="mr-stat-filter-hint mal-text" v-if="statusFilter">
            {{ statusFilterLabel }} മാത്രം കാണിക്കുന്നു
            <a href="javascript:void(0)" @click="statusFilter = null">(എല്ലാം കാണിക്കുക)</a>
        </p>
    </div>

    <!-- Wisdom Day "not held" report (state admin only) -->
    <div class="section mt-2" v-if="showNotHeldReport">
        <div class="mr-alert-card">
        <button type="button" class="mr-alert-toggle" @click="toggleNotHeldReport">
            <span class="mr-alert-toggle-left">
                <ion-icon name="alert-circle-outline"></ion-icon>
                <span class="mal-text">നടക്കാത്ത മണ്ഡലം / ശാഖ റിപ്പോർട്ട്</span>
            </span>
            <ion-icon :name="nh_open ? 'chevron-up-outline' : 'chevron-down-outline'"></ion-icon>
        </button>

        <div v-if="nh_open" class="mr-alert-body">
            <!-- Zones / Units toggle -->
            <div style="display:flex;gap:6px;margin-bottom:8px;">
                <button type="button" class="nh-tab" @click="nh_view='zones'"
                    :style="nh_view==='zones' ? 'background:#1a418c;color:#fff;' : 'background:#f1f5f9;color:#1a418c;'">
                    നടക്കാത്ത മണ്ഡലം ({{ nh_zones.length }})
                </button>
                <button type="button" class="nh-tab" @click="nh_view='units'"
                    :style="nh_view==='units' ? 'background:#1a418c;color:#fff;' : 'background:#f1f5f9;color:#1a418c;'">
                    നടക്കാത്ത ശാഖ ({{ nh_units.length }})
                </button>
            </div>

            <div v-if="nh_loading" class="text-center py-3"><div class="spinner-border text-primary"></div></div>

            <template v-else>
                <!-- Zones not held (grouped by district) -->
                <div v-if="nh_view==='zones'">
                    <div v-if="!nh_zones.length" class="text-center text-success py-3" style="font-size:13px;">
                        എല്ലാ മണ്ഡലങ്ങളിലും നടന്നു ✅
                    </div>
                    <div v-for="(dg, di) in nhZonesByDistrict" :key="'nhz_'+di" class="mb-2">
                        <div style="font-size:12px;font-weight:800;color:#c0392b;margin-bottom:4px;">{{ dg.district_name }}</div>
                        <div v-for="z in dg.zones" :key="'z_'+z.zone_id"
                            style="display:flex;align-items:center;justify-content:space-between;background:#fff5f5;border:1px solid #f5c6c6;border-radius:8px;padding:8px 12px;margin-bottom:5px;">
                            <span style="font-size:13px;font-weight:700;color:#27173E;">{{ z.zone_name }}</span>
                            <span style="font-size:11px;color:#94a3b8;">{{ z.units_count }} ശാഖ</span>
                        </div>
                    </div>
                </div>

                <!-- Units not held (grouped by district → zone) -->
                <div v-else>
                    <div v-if="!nh_units.length" class="text-center text-success py-3" style="font-size:13px;">
                        എല്ലാ ശാഖകളിലും നടന്നു ✅
                    </div>
                    <div v-if="nh_units.length" class="mb-2">
                        <select v-model="nh_unit_zone_filter" class="form-control custom-select">
                            <option value="">എല്ലാ മണ്ഡലം ({{ nh_units.length }})</option>
                            <option v-for="z in nhUnitZoneOptions" :key="'nhzf_'+(z.zone_id || z.zone_name)" :value="z.zone_id">
                                {{ z.zone_name }} ({{ z.count }})
                            </option>
                        </select>
                    </div>
                    <div v-for="(dg, di) in nhUnitsByDistrict" :key="'nhu_'+di" class="mb-2">
                        <div style="font-size:12px;font-weight:800;color:#c0392b;margin-bottom:4px;">{{ dg.district_name }}</div>
                        <div v-for="(zg, zi) in dg.zones" :key="'nhuz_'+zi" style="margin-bottom:6px;">
                            <!-- Zone header: name + unit count + collapse chevron -->
                            <div @click="toggleNhZone(zg.zone_key)"
                                style="display:flex;align-items:center;justify-content:space-between;background:#eef2ff;border:1px solid #dbe3ff;border-radius:8px;padding:8px 12px;cursor:pointer;">
                                <span style="font-size:13px;font-weight:700;color:#1a418c;">{{ zg.zone_name }}</span>
                                <span style="display:flex;align-items:center;gap:6px;">
                                    <span style="font-size:11px;font-weight:700;color:#c0392b;background:#fff;border-radius:10px;padding:1px 8px;">{{ zg.units.length }}</span>
                                    <ion-icon :name="isNhZoneCollapsed(zg.zone_key) ? 'chevron-down-outline' : 'chevron-up-outline'" style="font-size:15px;color:#1a418c;"></ion-icon>
                                </span>
                            </div>
                            <!-- Units (collapsed by default) -->
                            <div v-show="!isNhZoneCollapsed(zg.zone_key)" style="padding:4px 0 2px;">
                                <div v-for="u in zg.units" :key="'u_'+u.unit_id"
                                    style="background:#fff5f5;border:1px solid #f5c6c6;border-radius:8px;padding:7px 12px;margin:4px 0 0;font-size:13px;font-weight:700;color:#27173E;">
                                    {{ u.unit_name }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </div>
        </div>
    </div>

    <div class="section text-center" v-if="loading_list">
        <div class="spinner-border text-secondary" role="status"></div>
    </div>

    <div class="listed-detail mt-0">
        <h4 class="text-center mt-0 mal-text" v-if="!loading_list && member_lists.total <= 0">{{ $t('no_members_added') }}</h4>
    </div>
    <div class="modal fade action-sheet" id="nerpathamTargetModel" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ $t('nerpatham_target') }}</h5>
                </div>
                <div class="modal-body">
                    <div class="action-sheet-content">
                        <Form @submit="addNerpathamTarget">
                            <div class="form-group basic">
                                <label class="label" for="Target">{{ $t('target') }}</label>
                                <div class="form-group boxed">
                                    <Field name="target" type="number" class="form-control" id="target"
                                        v-model="nerpatham_target" placeholder="Enter Target" />
                                </div>
                                <input type="hidden" v-model="sub_level_id">
                                <div class="form-group" v-if="message">
                                    <div v-if="message" class="error-feedback">
                                        {{ message }}
                                    </div>
                                </div>
                            </div>
                            <div class="form-group basic">
                                <button type="submit" class="btn btn-primary btn-block btn-lg" :disabled="loading">
                                    <span v-show="loading" class="spinner-border spinner-border-sm"></span>
                                    <span>{{ $t('save') }}</span></button>
                            </div>
                        </Form>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="section mt-2 mb-2" v-if="!loading_list">
        <!-- Meeting Level = District/Zone/Unit determines both WHAT the report rows are (an
             entity's own meetings, not an aggregate "X of Y children") and how they're grouped —
             flat when every entity is directly in the viewer's own scope, otherwise nested under
             collapsible district/zone labels so a state-wide Unit list (~500 rows) stays usable.
             A wide date range can span several separate meetings per entity (e.g. three months
             of monthly meetings), so each card lists EVERY meeting in the window (newest first),
             not just one — see mr-status-card-body below. Only whether a wing attendance
             breakdown is present per meeting differs (Unit level only). -->
        <template v-if="listType === 'flat'">
            <div class="mr-status-card" v-for="sub_level in filteredMemberLists" :key="sub_level.id">
                <div class="mr-status-card-header">
                    <span class="mr-status-card-name mal-text">{{ sub_level.name }}</span>
                    <button v-if="statusFilter === 'not_scheduled'" type="button" class="mr-wa-btn"
                        :disabled="notifyingSecretaryKey === sub_level.id" @click="notifySecretary(sub_level.id, [sub_level.name], sub_level.name)">
                        <ion-icon name="logo-whatsapp"></ion-icon>
                    </button>
                    <span class="mr-group-count">{{ sub_level.meetings.length }}</span>
                </div>
                <div class="mr-status-card-status mr-status-card-status-none mal-text" v-if="!sub_level.meetings.length">ഇതുവരെ രേഖപ്പെടുത്തിയിട്ടില്ല</div>
                <div class="mr-meeting-row" v-for="mtg in sub_level.meetings" :key="mtg.id">
                    <div class="mr-meeting-row-top">
                        <span class="mal-text" v-html="mtg.status_html"></span>
                        <span v-if="mtg.date" class="meeting-date-badge">{{ mtg.date }}</span>
                    </div>
                    <div class="mobile-attendance-section" v-if="mtg.wing_counts">
                        <div class="mobile-label">{{ $t('attendance') }}</div>
                        <div class="mobile-attendance-grid">
                            <div class="mobile-attendance-item">
                                <span class="attendance-badge badge-ws">WS</span>
                                <span class="attendance-value">{{ mtg.wing_counts.wisdom }}/{{ mtg.wing_counts.wisdom_total }}</span>
                            </div>
                            <div class="mobile-attendance-item">
                                <span class="attendance-badge badge-yt">YT</span>
                                <span class="attendance-value">{{ mtg.wing_counts.youth }}/{{ mtg.wing_counts.youth_total }}</span>
                            </div>
                            <div class="mobile-attendance-item">
                                <span class="attendance-badge badge-st">ST</span>
                                <span class="attendance-value">{{ mtg.wing_counts.students }}/{{ mtg.wing_counts.students_total }}</span>
                            </div>
                            <div class="mobile-attendance-item">
                                <span class="attendance-badge badge-wm">WM</span>
                                <span class="attendance-value">{{ mtg.wing_counts.women }}/{{ mtg.wing_counts.women_total }}</span>
                            </div>
                            <div class="mobile-attendance-item">
                                <span class="attendance-badge badge-gl">GL</span>
                                <span class="attendance-value">{{ mtg.wing_counts.girls }}/{{ mtg.wing_counts.girls_total }}</span>
                            </div>
                        </div>
                        <div class="mobile-attendance-total" v-if="mtg.attendance">
                            <span class="total-label">Total:</span>
                            <span class="total-value">{{ mtg.attendance }}</span>
                        </div>
                    </div>
                    <div class="mr-status-card-attendance mal-text" v-else-if="mtg.attendance">{{ $t('attendance') }}: {{ mtg.attendance }}</div>
                </div>
            </div>
        </template>

        <!-- State, Meeting Level = Zone: zones grouped under collapsible district headers. -->
        <template v-else-if="listType === 'grouped_district'">
            <div class="mr-group-card" v-for="g in groupedByDistrict" :key="g.name">
                <div class="mr-group-toggle" @click="toggleGroup(g.name)">
                    <span class="mr-group-toggle-left mal-text">{{ g.name }}</span>
                    <button v-if="statusFilter === 'not_scheduled'" type="button" class="mr-wa-btn"
                        :disabled="notifyingSecretaryKey === g.items[0].district_id" @click.stop="notifySecretary(g.items[0].district_id, g.items.map(i => i.name), g.name)">
                        <ion-icon name="logo-whatsapp"></ion-icon>
                    </button>
                    <span class="mr-group-count">{{ g.items.length }}</span>
                    <ion-icon :name="isGroupCollapsed(g.name) ? 'chevron-down-outline' : 'chevron-up-outline'"></ion-icon>
                </div>
                <div class="mr-group-body" v-show="!isGroupCollapsed(g.name)">
                    <div class="mr-status-card mr-status-card-nested" v-for="sub_level in g.items" :key="sub_level.id">
                        <div class="mr-status-card-header">
                            <span class="mr-status-card-name mal-text">{{ sub_level.name }}</span>
                            <span class="mr-group-count">{{ sub_level.meetings.length }}</span>
                        </div>
                        <div class="mr-status-card-status mr-status-card-status-none mal-text" v-if="!sub_level.meetings.length">ഇതുവരെ രേഖപ്പെടുത്തിയിട്ടില്ല</div>
                        <div class="mr-meeting-row" v-for="mtg in sub_level.meetings" :key="mtg.id">
                            <div class="mr-meeting-row-top">
                                <span class="mal-text" v-html="mtg.status_html"></span>
                                <span v-if="mtg.date" class="meeting-date-badge">{{ mtg.date }}</span>
                            </div>
                            <div class="mr-status-card-attendance mal-text" v-if="mtg.attendance">{{ $t('attendance') }}: {{ mtg.attendance }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </template>

        <!-- District, Meeting Level = Unit: units grouped under collapsible zone headers. -->
        <template v-else-if="listType === 'grouped_zone'">
            <div class="mr-group-card" v-for="g in groupedByZone" :key="g.name">
                <div class="mr-group-toggle" @click="toggleGroup(g.name)">
                    <span class="mr-group-toggle-left mal-text">{{ g.name }}</span>
                    <button v-if="statusFilter === 'not_scheduled'" type="button" class="mr-wa-btn"
                        :disabled="notifyingSecretaryKey === g.items[0].zone_id" @click.stop="notifySecretary(g.items[0].zone_id, g.items.map(i => i.name), g.name)">
                        <ion-icon name="logo-whatsapp"></ion-icon>
                    </button>
                    <span class="mr-group-count">{{ g.items.length }}</span>
                    <ion-icon :name="isGroupCollapsed(g.name) ? 'chevron-down-outline' : 'chevron-up-outline'"></ion-icon>
                </div>
                <div class="mr-group-body" v-show="!isGroupCollapsed(g.name)">
                    <div class="mr-status-card mr-status-card-nested" v-for="sub_level in g.items" :key="sub_level.id">
                        <div class="mr-status-card-header">
                            <span class="mr-status-card-name mal-text">{{ sub_level.name }}</span>
                            <span class="mr-group-count">{{ sub_level.meetings.length }}</span>
                        </div>
                        <div class="mr-status-card-status mr-status-card-status-none mal-text" v-if="!sub_level.meetings.length">ഇതുവരെ രേഖപ്പെടുത്തിയിട്ടില്ല</div>
                        <div class="mr-meeting-row" v-for="mtg in sub_level.meetings" :key="mtg.id">
                            <div class="mr-meeting-row-top">
                                <span class="mal-text" v-html="mtg.status_html"></span>
                                <span v-if="mtg.date" class="meeting-date-badge">{{ mtg.date }}</span>
                            </div>
                            <div class="mobile-attendance-section" v-if="mtg.wing_counts">
                                <div class="mobile-label">{{ $t('attendance') }}</div>
                                <div class="mobile-attendance-grid">
                                    <div class="mobile-attendance-item">
                                        <span class="attendance-badge badge-ws">WS</span>
                                        <span class="attendance-value">{{ mtg.wing_counts.wisdom }}/{{ mtg.wing_counts.wisdom_total }}</span>
                                    </div>
                                    <div class="mobile-attendance-item">
                                        <span class="attendance-badge badge-yt">YT</span>
                                        <span class="attendance-value">{{ mtg.wing_counts.youth }}/{{ mtg.wing_counts.youth_total }}</span>
                                    </div>
                                    <div class="mobile-attendance-item">
                                        <span class="attendance-badge badge-st">ST</span>
                                        <span class="attendance-value">{{ mtg.wing_counts.students }}/{{ mtg.wing_counts.students_total }}</span>
                                    </div>
                                    <div class="mobile-attendance-item">
                                        <span class="attendance-badge badge-wm">WM</span>
                                        <span class="attendance-value">{{ mtg.wing_counts.women }}/{{ mtg.wing_counts.women_total }}</span>
                                    </div>
                                    <div class="mobile-attendance-item">
                                        <span class="attendance-badge badge-gl">GL</span>
                                        <span class="attendance-value">{{ mtg.wing_counts.girls }}/{{ mtg.wing_counts.girls_total }}</span>
                                    </div>
                                </div>
                                <div class="mobile-attendance-total" v-if="mtg.attendance">
                                    <span class="total-label">Total:</span>
                                    <span class="total-value">{{ mtg.attendance }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>

        <!-- State, Meeting Level = Unit: units grouped under collapsible district headers, each
             containing collapsible zone sub-groups. -->
        <template v-else-if="listType === 'grouped_district_zone'">
            <div class="mr-group-card" v-for="dg in groupedByDistrictZone" :key="dg.name">
                <div class="mr-group-toggle" @click="toggleGroup(dg.name)">
                    <span class="mr-group-toggle-left mal-text">{{ dg.name }}</span>
                    <button v-if="statusFilter === 'not_scheduled'" type="button" class="mr-wa-btn"
                        :disabled="notifyingSecretaryKey === dg.zones[0].items[0].district_id"
                        @click.stop="notifySecretary(dg.zones[0].items[0].district_id, dg.zones.flatMap(z => z.items.map(i => i.name)), dg.name)">
                        <ion-icon name="logo-whatsapp"></ion-icon>
                    </button>
                    <span class="mr-group-count">{{ dg.zones.reduce((s, z) => s + z.items.length, 0) }}</span>
                    <ion-icon :name="isGroupCollapsed(dg.name) ? 'chevron-down-outline' : 'chevron-up-outline'"></ion-icon>
                </div>
                <div class="mr-group-body mr-group-body-nested" v-show="!isGroupCollapsed(dg.name)">
                    <div class="mr-subgroup" v-for="zg in dg.zones" :key="dg.name + '_' + zg.name">
                        <button type="button" class="mr-subgroup-toggle" @click="toggleGroup(dg.name + '_' + zg.name)">
                            <span class="mr-subgroup-toggle-left mal-text">{{ zg.name }}</span>
                            <span class="mr-group-count">{{ zg.items.length }}</span>
                            <ion-icon :name="isGroupCollapsed(dg.name + '_' + zg.name) ? 'chevron-down-outline' : 'chevron-up-outline'"></ion-icon>
                        </button>
                        <div class="mr-group-body" v-show="!isGroupCollapsed(dg.name + '_' + zg.name)">
                            <div class="mr-status-card mr-status-card-nested" v-for="sub_level in zg.items" :key="sub_level.id">
                                <div class="mr-status-card-header">
                                    <span class="mr-status-card-name mal-text">{{ sub_level.name }}</span>
                                    <span class="mr-group-count">{{ sub_level.meetings.length }}</span>
                                </div>
                                <div class="mr-status-card-status mr-status-card-status-none mal-text" v-if="!sub_level.meetings.length">ഇതുവരെ രേഖപ്പെടുത്തിയിട്ടില്ല</div>
                                <div class="mr-meeting-row" v-for="mtg in sub_level.meetings" :key="mtg.id">
                                    <div class="mr-meeting-row-top">
                                        <span class="mal-text" v-html="mtg.status_html"></span>
                                        <span v-if="mtg.date" class="meeting-date-badge">{{ mtg.date }}</span>
                                    </div>
                                    <div class="mobile-attendance-section" v-if="mtg.wing_counts">
                                        <div class="mobile-label">{{ $t('attendance') }}</div>
                                        <div class="mobile-attendance-grid">
                                            <div class="mobile-attendance-item">
                                                <span class="attendance-badge badge-ws">WS</span>
                                                <span class="attendance-value">{{ mtg.wing_counts.wisdom }}/{{ mtg.wing_counts.wisdom_total }}</span>
                                            </div>
                                            <div class="mobile-attendance-item">
                                                <span class="attendance-badge badge-yt">YT</span>
                                                <span class="attendance-value">{{ mtg.wing_counts.youth }}/{{ mtg.wing_counts.youth_total }}</span>
                                            </div>
                                            <div class="mobile-attendance-item">
                                                <span class="attendance-badge badge-st">ST</span>
                                                <span class="attendance-value">{{ mtg.wing_counts.students }}/{{ mtg.wing_counts.students_total }}</span>
                                            </div>
                                            <div class="mobile-attendance-item">
                                                <span class="attendance-badge badge-wm">WM</span>
                                                <span class="attendance-value">{{ mtg.wing_counts.women }}/{{ mtg.wing_counts.women_total }}</span>
                                            </div>
                                            <div class="mobile-attendance-item">
                                                <span class="attendance-badge badge-gl">GL</span>
                                                <span class="attendance-value">{{ mtg.wing_counts.girls }}/{{ mtg.wing_counts.girls_total }}</span>
                                            </div>
                                        </div>
                                        <div class="mobile-attendance-total" v-if="mtg.attendance">
                                            <span class="total-label">Total:</span>
                                            <span class="total-value">{{ mtg.attendance }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>

    <alert-model :type="alert_type" :message="alert_message" ref="alert_model"></alert-model>
    <dialog-model :message="dialog_message" :action_method="dialog_action" :action_method_params="dialog_action_params"
        ref="dialog_model"></dialog-model>
</template>

<script>
import { Form, Field } from "vee-validate";
import UserService from "../../services/user.service";
import $ from 'jquery';
import AlertModel from "./../layouts/AlertModel.vue";
import DialogModel from "./../layouts/DialogModel.vue";
import moment from 'moment';
export default {
    name: 'Nerpatham Report',
    components: {
        Form,
        Field,
        AlertModel,
        DialogModel
    },
    props: {
        unit_id: null
    },
    data() {
        return {
            loading: false,
            loading_list: false,
            meeting_list: [
                {
                    'id' : 1,
                    'name' : 'Secretariate'
                },
                {
                    'id' : 2,
                    'name' : 'Executive'
                },
                {
                    'id' : 3,
                    'name' : 'Departmental'
                },
                {
                    'id' : 4,
                    'name' : 'General Body'
                },
                {
                    'id' : 5,
                    'name' : 'Council'
                },
                {
                    'id' : 6,
                    'name' : 'Joint Secretariat'
                },
                {
                    'id' : 7,
                    'name' : 'Wisdom Day'
                },
                {
                    'id' : 8,
                    'name' : 'Special Meetings'
                },
            ],
            filter_meeting: '',
            filter_region: 'kerala',
            // The ORG LEVEL the searched meeting type is actually held AT (2=district, 3=zone,
            // 4=unit) — e.g. a "Secretariate" meeting is usually one Zone-level event, while
            // "Wisdom Day" is one event PER UNIT. A required filter (like meeting type/date),
            // not inferred from the viewer's own scope — see the backend comment on
            // getMeetingReport() for why.
            filter_meeting_level: '',
            // How the backend says `member_lists` should be rendered: 'flat' (every entity is
            // directly in the viewer's own scope) or 'grouped_district' / 'grouped_zone' /
            // 'grouped_district_zone' (grouped client-side under collapsible district/zone
            // labels so a state-wide Unit list, ~500 rows, stays usable).
            listType: 'flat',
            mr_collapsed_groups: {},
            // Which group's WhatsApp-notify request is in flight — keyed by that group's own
            // target-level id (district_id/zone_id/unit_id), so only that one button disables.
            notifyingSecretaryKey: null,
            // Clicking a stat card filters the list below to just that status — null shows
            // everything (including entities with zero meetings recorded).
            statusFilter: null,
            // "Not held" report (state admin, Wisdom Day) — driven by the applied Search filter
            nh_open: false,
            nh_loading: false,
            nh_loaded: false,
            nh_view: 'zones',   // 'zones' | 'units'
            nh_zones: [],
            nh_units: [],
            nh_unit_zone_filter: '',   // zone_id filter for the units list
            nh_collapsed_zones: {},    // zone_key -> collapsed? (units accordion)
            nh_searched_meeting: '',   // meeting type that was actually searched
            nh_from: '',               // searched date range (captured on Search)
            nh_to: '',
            nh_region_used: 'kerala',
            filter_date_from: '',
            filter_date_to: '',
            message: "",
            country_code: '91',
            country_code_whatsapp: '91',
            mobile_number: '',
            whatsapp_number: '',
            wing: '',
            stay: '',
            user_level: "",
            sub_levels: [],
            member_lists: [],
            member_list: [],
            member: [],
            member_edit: true,
            orgnal_member_lists: [],
            trash_list: [],
            unit: [],
            editable_id: '',
            editable: false,
            permissions: [],
            add_admin: false,
            abroad_fields: false,
            pin_number: '',
            attendance: 'A',
            attendance_remarks: '',
            search_qty: '',
            member_id: '',
            alert_type: '',
            alert_message: '',
            dialog_message: '',
            dialog_action: '',
            dialog_action_params: [],
            attendance_present: [],
            attendance_absent: [],
            filter_wing: '',
            isMember: '',
            isSubscriber: '',
            receipt_no: '',
            subscription_no: '',
            isEdit: false,
            count_total: 0,
            count_target: 0,
            level: [],
            nerpatham_target: '',
            target_title: 'ടാർഗറ്റ്',
            page_title: 'വർക്കിങ് ഫണ്ട് റിപ്പോർട്ട്',
            series: [0, 0],
            chartOptions: {
                chart: {
                    width: '100%',
                    type: 'pie',
                },
                colors: ['#64b167', '#db7491'],
                labels: ['Target', 'Total'],
                responsive: [{
                    breakpoint: 100,
                    options: {
                        chart: {
                            width: '100%'
                        },
                        legend: {
                            position: 'bottom'
                        }
                    }
                }]
            },
            count_state: 0,
            count_unit: 0,
            count_zone: 0,
            count_district: 0,
            count_confirmed: 0.00,

        };
    },

    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
        // Show the "not held" report only for state admin AFTER a Wisdom Day (sublevel 7) search
        showNotHeldReport() {
            return this.user_level === 1 && String(this.nh_searched_meeting) === '7';
        },
        // Zones-not-held grouped by district
        nhZonesByDistrict() {
            const map = {};
            (this.nh_zones || []).forEach(z => {
                const key = z.district_id || ('n_' + z.district_name);
                if (!map[key]) map[key] = { district_name: z.district_name || 'Unknown', zones: [] };
                map[key].zones.push(z);
            });
            return Object.values(map);
        },
        // Distinct zones present in the not-held units list (for the dropdown)
        nhUnitZoneOptions() {
            const map = {};
            (this.nh_units || []).forEach(u => {
                const key = u.zone_id || ('n_' + u.zone_name);
                if (!map[key]) map[key] = { zone_id: u.zone_id, zone_name: u.zone_name || 'Unknown', district_name: u.district_name || '', count: 0 };
                map[key].count++;
            });
            return Object.values(map).sort((a, b) =>
                (a.district_name || '').localeCompare(b.district_name || '') || (a.zone_name || '').localeCompare(b.zone_name || '')
            );
        },
        // Units-not-held grouped by district → zone (respects the zone dropdown filter)
        nhUnitsByDistrict() {
            const dmap = {};
            let units = this.nh_units || [];
            if (this.nh_unit_zone_filter !== '') {
                units = units.filter(u => String(u.zone_id) === String(this.nh_unit_zone_filter));
            }
            units.forEach(u => {
                const dkey = u.district_id || ('n_' + u.district_name);
                if (!dmap[dkey]) dmap[dkey] = { district_name: u.district_name || 'Unknown', zones: {} };
                const zkey = u.zone_id || ('n_' + u.zone_name);
                if (!dmap[dkey].zones[zkey]) dmap[dkey].zones[zkey] = { zone_key: String(zkey), zone_id: u.zone_id, zone_name: u.zone_name || 'Unknown', units: [] };
                dmap[dkey].zones[zkey].units.push(u);
            });
            return Object.values(dmap).map(d => ({ district_name: d.district_name, zones: Object.values(d.zones) }));
        },
        // Which "Meeting Level" options this viewer can search — a meeting type could be a
        // single District-level event, one per Zone, or one per Unit, and only the levels at or
        // below the viewer's own scope have any sub-entities worth listing (a District admin
        // checking "did MY district hold it" is just one boolean, not a list, so District isn't
        // offered to them — only State can meaningfully compare across many districts).
        meetingLevelOptions() {
            if (this.user_level === 1) {
                return [
                    { level: 2, label: this.$t('district') },
                    { level: 3, label: this.$t('zone') },
                    { level: 4, label: 'ശാഖ' },
                ];
            }
            if (this.user_level === 2) {
                return [
                    { level: 3, label: this.$t('zone') },
                    { level: 4, label: 'ശാഖ' },
                ];
            }
            return [{ level: 4, label: 'ശാഖ' }];
        },
        // Clicking a stat card (Target/Confirmed/Done) filters `member_lists` down to entities
        // that have at least one meeting matching that status — 'target' just requires any
        // meeting to exist (hides entities with none recorded), 'confirmed'/'done' filter each
        // entity's own `meetings` array too, so a card only shows the meetings that qualify.
        // "Not Scheduled" = meetings still sitting at status_level 1 ("നിശ്ചയിച്ചത്" — decided/
        // bulk-created but no date picked and not yet confirmed) — target minus confirmed, since
        // target already counts every non-deleted meeting in the window regardless of status.
        notScheduledCount() {
            return Math.max(0, this.count_target - this.count_confirmed);
        },
        filteredMemberLists() {
            if (!this.statusFilter) return this.member_lists || [];
            return (this.member_lists || []).map(item => {
                let meetings = item.meetings || [];
                if (this.statusFilter === 'confirmed') meetings = meetings.filter(m => m.status_level >= 2);
                else if (this.statusFilter === 'done') meetings = meetings.filter(m => m.status_level === 4);
                else if (this.statusFilter === 'not_scheduled') meetings = meetings.filter(m => m.status_level === 1);
                return Object.assign({}, item, { meetings });
            }).filter(item => item.meetings.length > 0);
        },
        statusFilterLabel() {
            if (this.statusFilter === 'target') return this.$t('target');
            if (this.statusFilter === 'confirmed') return this.$t('confirmed');
            if (this.statusFilter === 'done') return this.$t('increase');
            if (this.statusFilter === 'not_scheduled') return 'നിശ്ചയിച്ചിട്ടില്ലാത്തത്';
            return '';
        },
        // Flattened multi-hop reports (grouped client-side so hundreds of rows stay readable) —
        // one computed per grouping shape the backend can return via `list_type`. Sourced from
        // filteredMemberLists so the active stat-card filter (if any) applies here too.
        groupedByDistrict() {
            // list_type 'grouped_district': rows are zones, grouped by district_name.
            const map = {};
            (this.filteredMemberLists || []).forEach(item => {
                const key = item.district_name || 'Unknown';
                if (!map[key]) map[key] = { name: key, items: [] };
                map[key].items.push(item);
            });
            return Object.values(map);
        },
        groupedByZone() {
            // list_type 'grouped_zone': rows are units, grouped by zone_name.
            const map = {};
            (this.filteredMemberLists || []).forEach(item => {
                const key = item.zone_name || 'Unknown';
                if (!map[key]) map[key] = { name: key, items: [] };
                map[key].items.push(item);
            });
            return Object.values(map);
        },
        groupedByDistrictZone() {
            // list_type 'grouped_district_zone': rows are units, grouped by district → zone.
            const dmap = {};
            (this.filteredMemberLists || []).forEach(item => {
                const dkey = item.district_name || 'Unknown';
                if (!dmap[dkey]) dmap[dkey] = { name: dkey, zones: {} };
                const zkey = item.zone_name || 'Unknown';
                if (!dmap[dkey].zones[zkey]) dmap[dkey].zones[zkey] = { name: zkey, items: [] };
                dmap[dkey].zones[zkey].items.push(item);
            });
            return Object.values(dmap).map(d => ({ name: d.name, zones: Object.values(d.zones) }));
        },
        minusToZero() {
            let value = this.count_target - this.count_total;
            if (value <= 0) {
                return '0';
            } else {
                return value.toFixed(2);
            }
        },
    },
    watch: {
        $route() {
            this.applyRouteFilters();
        }
    },
    mounted() {
        if (!this.currentUser) {
            location.replace('/');
        } else {
            this.user_level = parseInt(this.$route.params.sub_level);
            this.applyRouteFilters();

            this.$root.updateParent('Meeting Report');
        }

        window.onpopstate = function () {
            if ($('body').hasClass('modal-open')) {
                location.reload();
            }
        };

        // Re-apply filters when user navigates back to this page
        window.addEventListener('popstate', this.applyRouteFilters);
    },
    beforeUnmount() {
        window.removeEventListener('popstate', this.applyRouteFilters);
    },
    methods: {
        applyRouteFilters() {
            const q = (this.$route && this.$route.query) ? this.$route.query : {};
            let meeting = q.meeting_type || '';
            let from = q.date_from || '';
            let to = q.date_to || '';
            let region = q.region || '';
            let meetingLevel = q.meeting_level ? parseInt(q.meeting_level, 10) : null;
            // No query params (e.g. Back navigation to the top page) → restore last-used filters
            if (!meeting && !from && !to) {
                try {
                    const saved = JSON.parse(localStorage.getItem('meetingReportFilters') || 'null');
                    if (saved) {
                        meeting = saved.meeting || '';
                        from = saved.date_from || '';
                        to = saved.date_to || '';
                        region = saved.region || '';
                        if (!meetingLevel) meetingLevel = saved.meeting_level || null;
                    }
                } catch (e) { /* ignore */ }
            }
            this.filter_date_from = from || moment(new Date()).format('YYYY-MM-DD');
            this.filter_date_to = to || moment(new Date()).format('YYYY-MM-DD');
            if (meeting) this.filter_meeting = meeting;
            if (region) this.filter_region = region;
            // Only trust a restored level if it's actually valid for THIS screen's level (e.g. a
            // Zone admin's page has no District/Zone option) — else leave it for the admin to
            // pick, unless there's only one option anyway (a Zone admin only ever has "Unit"),
            // in which case there's no real choice to make so just pre-select it.
            const validLevels = this.meetingLevelOptions.map(t => t.level);
            if (meetingLevel && validLevels.includes(meetingLevel)) {
                this.filter_meeting_level = meetingLevel;
            } else if (this.meetingLevelOptions.length === 1) {
                this.filter_meeting_level = this.meetingLevelOptions[0].level;
            } else {
                this.filter_meeting_level = '';
            }
            if (this.filter_meeting && this.filter_meeting_level && this.filter_date_from && this.filter_date_to) {
                this.getMembersList();
            }
        },
        updateChart() {
            this.chartOptions = {
                chart: {
                    type: 'pie'
                },
                colors: ['#64b167', '#db7491'],
                labels: ['ചേർത്തത്', 'ബാക്കി ഉള്ളത്'],
                responsive: [{
                    breakpoint: this.count_target,
                    options: {
                        chart: {
                            width: '100%'
                        },
                        legend: {
                            show: false,
                        }
                    }
                }]
            }
            // In the same way, update the series option
            this.series = [parseFloat(this.count_total), parseFloat(this.count_target - this.count_total)]
        },
        adminView(admin) {
            $('#addAdminModel').modal('show');
            this.message = '';
            this.isEdit = true;
            if (admin.member_id) {
                this.member_id = admin.member_id;
                this.disable_member_form = true;
            } else {
                this.disable_member_form = false;
            }
            this.name = admin.name;
            this.mobile = admin.mobile;
            this.subscription_no = admin.subscription_no;
            this.receipt_no = admin.reciept_no;
            this.member_edit = false;
            this.member_list.push(this.member);
            this.designation = admin.designation;
            this.editable_id = admin.id;
            this.add_admin = false;
            this.edit_admin = true;
        },
        adminAdd() {
            $('#addAdminModel').modal('show');
            this.disable_member_form = false;
            this.message = '';
            this.member_id = '';
            this.name = '';
            this.mobile = '';
            this.subscription_no = '';
            this.receipt_no = '';
            this.member_edit = true;
            this.member = '';
            this.editable_id = null;
            this.add_admin = true;
            this.edit_admin = false;
        },
        closeAddAdminModel() {
            $('#addAdminModel').modal('hide');
        },
        addAdmin(user) {
            console.log(user);
            user.editable_id = this.editable_id;
            user.is_member = this.isMember;
            if (!this.member && this.isMember == 'Y') {
                this.message = 'ദയവായി മെമ്പറെ ലിസ്റ്റിൽ നിന്നും സെലക്ട് ചെയ്തതിനു ശേഷം Save അമർത്തുക';
            }
            if (this.member) {
                user.member_id = this.member.id;
            }
            user.unit_id = parseInt(this.$route.params.id);
            UserService.addAdmin('store-nerpatham-subscriptions', user).then(
                (response) => {
                    if (response.data.status == 'success') {
                        $('#addAdminModel').modal('hide')
                        this.alert_type = 'Success';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.getMembersList();
                        this.loading = false;
                        this.message = '';
                    } else if (response.data.status == 'warning') {
                        this.alert_type = 'Warning';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    } else if (response.data.status == 'error') {
                        this.alert_type = 'Error';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    } else {
                        this.loading = false;
                    }
                },
                (error) => {
                    this.loading = false;

                    this.messafe = (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
        adminDeleteConfirmation(admin_list) {
            var data = {
                id: admin_list.id,
            }
            this.dialog_action_params = data;
            this.dialog_message = 'ശരിക്കും ഡിലീറ്റ് ചെയ്യണോ?';
            this.dialog_action = 'adminDelete';
            this.$refs.dialog_model.openModel();
            this.loading = false;
        },
        adminDelete(data) {
            UserService.authPostRequest('delate-nerpatham-subscriptions', data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.alert_type = 'Success';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.getMembersList();
                        this.loading = false;
                    } else if (response.data.status == 'warning') {
                        this.alert_type = 'Warning';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    } else {
                        this.alert_type = 'Error';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = true;
                    }
                },
                (error) => {
                    this.loading = false;
                    this.message =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
        getWing(wing) {
            if (wing == 1)
                return 'വിസ്‌ഡം';
            else if (wing == 2)
                return 'യൂത്ത്';
            else if (wing == 3)
                return 'സ്റ്റുഡന്റസ്';
            else if (wing == 4)
                return 'വിമെൻ';
            else
                return 'ഗേൾസ്';
        },
        toggleNotHeldReport() {
            this.nh_open = !this.nh_open;
            if (this.nh_open && !this.nh_loaded) this.loadNotHeld();
        },
        isNhZoneCollapsed(key) {
            // default collapsed (units hidden until the zone row is clicked)
            return this.nh_collapsed_zones[key] !== false;
        },
        toggleNhZone(key) {
            this.nh_collapsed_zones[key] = !this.isNhZoneCollapsed(key);
        },
        loadNotHeld() {
            // Uses the date range captured at Search time (not the live filter inputs).
            this.nh_loading = true;
            const data = {
                meeting: this.nh_searched_meeting,
                date_from: this.nh_from,
                date_to: this.nh_to,
                region: this.nh_region_used,
            };
            UserService.authPostRequest('get-meeting-not-held-report', data).then(
                (response) => {
                    this.nh_loading = false;
                    if (response.data.status === 'success') {
                        this.nh_zones = response.data.data.zones_not_held || [];
                        this.nh_units = response.data.data.units_not_held || [];
                        this.nh_loaded = true;
                    }
                },
                () => { this.nh_loading = false; }
            );
        },
        getMembersList() {
            let data = {
                user_level: this.user_level,
                user_level_id: parseInt(this.$route.params.id),
                meeting: this.filter_meeting,
                date_from: this.filter_date_from,
                date_to: this.filter_date_to,
                region: this.filter_region,
                meeting_level: this.filter_meeting_level
            }
            if (!this.filter_meeting_level) {
                this.alert_type = 'Warning';
                this.alert_message = 'മീറ്റിംഗ് ലെവൽ സെലക്ട് ചെയ്യുക.';
                this.$refs.alert_model.openModel();
                return 0;
            } else if (!this.filter_meeting) {
                this.alert_type = 'Warning';
                this.alert_message = 'മീറ്റിംഗ് ടൈപ്പ് സെലക്ട് ചെയ്യുക.';
                this.$refs.alert_model.openModel();
                return 0;
            } else if (!this.filter_date_from) {
                this.alert_type = 'Warning';
                this.alert_message = 'തീയതി സെലക്ട് ചെയ്യുക.';
                this.$refs.alert_model.openModel();
                return 0;
            } else if (!this.filter_date_to) {
                this.alert_type = 'Warning';
                this.alert_message = 'തീയതി സെലക്ട് ചെയ്യുക.';
                this.$refs.alert_model.openModel();
                return 0;
            }
            this.loading_list = true;
            this.statusFilter = null;
            this.mr_collapsed_groups = {};

            // Capture what was actually searched so the "not held" report matches the applied filter,
            // and reset it so it reloads (collapsed) for the new search.
            this.nh_searched_meeting = this.filter_meeting;
            this.nh_from = this.filter_date_from;
            this.nh_to = this.filter_date_to;
            this.nh_region_used = this.filter_region;
            this.nh_open = false;
            this.nh_loaded = false;
            this.nh_zones = [];
            this.nh_units = [];
            this.nh_unit_zone_filter = '';
            this.nh_collapsed_zones = {};

            // Persist filters so they survive Back-navigation from a drilled-down page
            try {
                localStorage.setItem('meetingReportFilters', JSON.stringify({
                    meeting: this.filter_meeting,
                    date_from: this.filter_date_from,
                    date_to: this.filter_date_to,
                    region: this.filter_region,
                    meeting_level: this.filter_meeting_level,
                }));
            } catch (e) { /* ignore */ }

            UserService.authPostRequest(`get-meeting-report`, data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.meeting_list = response.data.data.meetings;
                        this.member_lists = response.data.data.list;
                        this.listType = response.data.data.list_type || 'flat';
                        this.level = response.data.data.level;
                        this.count_target = response.data.data.count_target;
                        this.count_total = response.data.data.count_total;
                        this.count_confirmed = response.data.data.count_confirmed;
                        this.loading_list = false;
                        // this.updateChart();
                    } else {
                        this.loading_list = true;
                    }
                },
                (error) => {
                    this.loading = false;
                    this.message =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },

        showActionModel() {
            this.pin_number = '';
        },
        nerpathamTarget(sub_level = null) {
            this.nerpatham_target = sub_level.nerpatham_target;
            this.sub_level_id = sub_level.id;
            $('#nerpathamTargetModel').modal('show');
        },
        addNerpathamTarget(data) {
            data.level = parseInt(this.$route.params.sub_level) + 1;
            data.level_id = parseInt(this.sub_level_id);
            UserService.addAdmin('set-nerpatham-target', data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.getMembersList();
                        $('#nerpathamTargetModel').modal('hide')
                        this.alert_type = 'Success';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                        this.message = '';
                    } else if (response.data.status == 'warning') {
                        this.alert_type = 'Warning';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    } else if (response.data.status == 'error') {
                        this.alert_type = 'Error';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    } else {
                        this.loading = false;
                    }
                },
                (error) => {
                    this.loading = false;

                    this.messafe = (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
        clearFilter(){
            this.filter_meeting = '';
            this.filter_meeting_level = this.meetingLevelOptions.length === 1 ? this.meetingLevelOptions[0].level : '';
            this.filter_date_from = moment(new Date()).format('YYYY-MM-DD');
            this.filter_date_to = moment(new Date()).format('YYYY-MM-DD');
            this.mr_collapsed_groups = {};
            // hide the not-held report until a new search is run
            this.nh_searched_meeting = '';
            this.nh_open = false;
            this.nh_loaded = false;
            this.nh_zones = [];
            this.nh_units = [];
            // forget persisted filters
            try { localStorage.removeItem('meetingReportFilters'); } catch (e) { /* ignore */ }
        },
        // Collapsed by default — group rows only expand on tap, so a state-wide Zone/Unit
        // report (18 districts, 500+ units) doesn't dump everything open at once.
        isGroupCollapsed(key) {
            return this.mr_collapsed_groups[key] !== false;
        },
        toggleGroup(key) {
            this.mr_collapsed_groups[key] = !this.isGroupCollapsed(key);
        },
        toggleStatusFilter(key) {
            this.statusFilter = this.statusFilter === key ? null : key;
        },
        mobileToWhatsapp(mobile, countryCode) {
            const cleanNumber = (mobile || '').replace(/\D/g, '');
            const code = (countryCode || '91').replace(/\D/g, '') || '91';
            return code + cleanNumber;
        },
        // Notify the Secretary one level below the viewer (State→District, District→Zone,
        // Zone→Unit — see getMeetingSecretaryContact()'s own comment for why never skip-level)
        // about everything in `names` that hasn't scheduled its meeting yet. `targetLevelId` is
        // the district_id/zone_id/unit_id of the group the button sits on.
        notifySecretary(targetLevelId, names, groupLabel) {
            if (!targetLevelId || this.notifyingSecretaryKey) return;
            this.notifyingSecretaryKey = targetLevelId;
            const targetLevel = this.user_level + 1;
            UserService.authPostRequest('get-meeting-secretary-contact', { level: targetLevel, level_id: targetLevelId }).then(
                (response) => {
                    this.notifyingSecretaryKey = null;
                    const secretary = response.data && response.data.status === 'success'
                        ? (response.data.data.secretary || null)
                        : null;
                    if (!secretary || !secretary.mobile) {
                        this.alert_type = 'Warning';
                        this.alert_message = groupLabel + '-ന്റെ സെക്രട്ടറിയെ കണ്ടെത്താനായില്ല.';
                        this.$refs.alert_model.openModel();
                        return;
                    }
                    const meetingName = (this.meeting_list.find(m => m.id == this.filter_meeting) || {}).name || 'മീറ്റിംഗ്';
                    const message = `*${groupLabel}*\n\n${meetingName} ഇതുവരെ ഷെഡ്യൂൾ ചെയ്യാത്തവ:\n\n- ${names.join('\n- ')}\n\nദയവായി വേഗം ഷെഡ്യൂൾ ചെയ്യാൻ അഭ്യർത്ഥിക്കുന്നു.`;
                    const number = this.mobileToWhatsapp(secretary.mobile, secretary.country_code);
                    window.open(`https://wa.me/${number}?text=${encodeURIComponent(message)}`, '_blank');
                },
                () => {
                    this.notifyingSecretaryKey = null;
                    this.alert_type = 'Error';
                    this.alert_message = 'സെക്രട്ടറിയെ കണ്ടെത്തുന്നതിൽ പിശക് സംഭവിച്ചു.';
                    this.$refs.alert_model.openModel();
                }
            );
        },
    },
};
</script>
<style scoped>
.nh-tab {
    flex: 1;
    padding: 6px 6px;
    border: none;
    border-radius: 7px;
    font-size: 11px;
    font-weight: 700;
    line-height: 1.25;
    cursor: pointer;
}
.section-heading {
    padding: 10px 10px 0px 10px;
}

.error-feedback {
    color: red;
}

.stat-box .value {
    font-size: 18px;
    font-weight: 700;
    letter-spacing: -0.02em;
    line-height: 1em;
    color: #27173E;
}

/* Meeting Report — redesigned filter card */
.mr-filter-card {
    background: #fff;
    border: 1px solid #eef0f5;
    border-radius: 14px;
    box-shadow: 0 1px 3px 0 rgb(0 0 0 / 9%);
    overflow: hidden;
}

.mr-filter-header {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 12px 14px;
    background: #f4f7fb;
    border-bottom: 1px solid #eef0f5;
    font-size: 13px;
    font-weight: 700;
    color: #1a418c;
}

.mr-filter-header ion-icon {
    font-size: 16px;
}

.mr-filter-body {
    padding: 14px;
}

.mr-filter-row {
    display: flex;
    gap: 10px;
    margin-bottom: 10px;
}

.mr-filter-row:last-of-type {
    margin-bottom: 0;
}

.mr-filter-field {
    flex: 1;
    min-width: 0;
}

.mr-filter-label {
    display: block;
    font-size: 11.5px;
    font-weight: 700;
    color: #64748b;
    margin-bottom: 4px;
}

.mr-filter-field .form-control {
    border-radius: 8px;
}

.mr-filter-actions {
    display: flex;
    gap: 8px;
    margin-top: 10px;
}

.mr-btn {
    flex: 1;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    border: none;
    border-radius: 9px;
    padding: 8px 6px;
    font-size: 12px;
    font-weight: 700;
    white-space: nowrap;
    line-height: 1.2;
}

.mr-btn ion-icon {
    font-size: 14px;
    flex-shrink: 0;
}

.mr-btn-primary {
    background: #1a418c;
    color: #fff;
}

.mr-btn-ghost {
    background: #fff0f0;
    color: #d9534f;
    border: 1px solid #ffd9d9;
}

/* Meeting Report — redesigned stat cards */
.mr-stats-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 5px;
}

.mr-stat-card {
    background: #fff;
    border: 1px solid #eef0f5;
    border-radius: 10px;
    box-shadow: 0 1px 3px 0 rgb(0 0 0 / 9%);
    padding: 8px 4px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 2px;
    width: 100%;
    font-family: inherit;
    transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.mr-stat-card.active {
    border-color: #1a418c;
    box-shadow: 0 0 0 2px rgba(26, 65, 140, 0.18);
}

.mr-stat-filter-hint {
    text-align: center;
    font-size: 11.5px;
    color: #64748b;
    margin: 8px 0 0;
}

.mr-stat-filter-hint a {
    color: #1a418c;
    font-weight: 700;
    margin-left: 4px;
}

.mr-stat-icon {
    width: 22px;
    height: 22px;
    border-radius: 50%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
}

.mr-stat-target .mr-stat-icon {
    background: #fdf4f4;
    color: #d9534f;
}

.mr-stat-confirmed .mr-stat-icon {
    background: #eef2ff;
    color: #1a418c;
}

.mr-stat-increase .mr-stat-icon {
    background: #f0fdf4;
    color: #12a85a;
}

.mr-stat-not-scheduled .mr-stat-icon {
    background: #fff7ed;
    color: #b45309;
}

.mr-stat-value {
    font-size: 15px;
    font-weight: 800;
    letter-spacing: -0.02em;
    line-height: 1em;
    color: #27173E;
}

.mr-stat-label {
    font-size: 9px;
    font-weight: 700;
    color: #64748b;
    line-height: 1.15;
}

/* Meeting Report — redesigned "not held" alert card */
.mr-alert-card {
    background: #fff;
    border: 1px solid #eef0f5;
    border-radius: 12px;
    box-shadow: 0 1px 3px 0 rgb(0 0 0 / 9%);
    overflow: hidden;
}

.mr-alert-toggle {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    width: 100%;
    border: none;
    background: transparent;
    padding: 12px 14px;
    text-align: left;
    font-size: 13px;
    font-weight: 700;
    color: #c0392b;
}

.mr-alert-toggle-left {
    display: flex;
    align-items: center;
    gap: 6px;
    flex: 1;
    min-width: 0;
}

.mr-alert-toggle-left ion-icon {
    flex-shrink: 0;
    font-size: 16px;
}

.mr-alert-toggle > ion-icon:last-child {
    flex-shrink: 0;
    font-size: 16px;
    color: #adb5bd;
}

.mr-alert-body {
    padding: 10px 14px 14px;
    border-top: 1px solid #eef0f5;
}


/* Meeting Report — status card: one per entity's own single meeting (District, Zone, or Unit —
   whichever the "Meeting Level" filter picked), status badge + optional wing attendance. */
.mr-status-card {
    background: #fff;
    border: 1px solid #e9ecef;
    border-radius: 12px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
    padding: 14px;
}

.mr-status-card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    margin-bottom: 8px;
}

.mr-status-card-name {
    flex: 1;
    min-width: 0;
    font-weight: 700;
    font-size: 15px;
    color: #27173E;
}

.mr-status-card-status {
    font-size: 13px;
    color: #495057;
    background: #f8f9fb;
    border-radius: 8px;
    padding: 8px 10px;
    margin-bottom: 12px;
    font-weight: 600;
}

.mr-status-card-status-none {
    color: #94a3b8;
    font-weight: 500;
}

.mr-status-card-attendance {
    font-size: 12.5px;
    color: #6c757d;
    font-weight: 600;
}

/* Meeting Report — one row per individual meeting within a status card (a wide date range can
   span several separate meetings for the same entity) */
.mr-meeting-row {
    background: #f8f9fb;
    border-radius: 8px;
    padding: 8px 10px;
    margin-bottom: 8px;
}

.mr-meeting-row:last-child {
    margin-bottom: 0;
}

.mr-meeting-row-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
}

/* Meeting Report — flattened multi-hop reports: collapsible district/zone group accordions */
.mr-group-card {
    background: #fff;
    border: 1px solid #eef0f5;
    border-radius: 12px;
    box-shadow: 0 1px 3px 0 rgb(0 0 0 / 9%);
    margin-bottom: 10px;
    overflow: hidden;
}

.mr-group-toggle,
.mr-subgroup-toggle {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    width: 100%;
    border: none;
    background: transparent;
    padding: 12px 14px;
    text-align: left;
    font-size: 13.5px;
    font-weight: 700;
    color: #1a418c;
    cursor: pointer;
}

/* WhatsApp "notify secretary" button — nested inside a group-toggle row, so it's a real
   <button> even though the row itself had to become a <div> (a <button> can't contain another
   interactive <button>); @click.stop on it keeps a tap from also toggling the group open/closed. */
.mr-wa-btn {
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 26px;
    height: 26px;
    border: none;
    border-radius: 50%;
    background: #e9f9ef;
    color: #25d366;
    font-size: 15px;
    padding: 0;
}

.mr-wa-btn:disabled {
    opacity: 0.5;
}

.mr-subgroup-toggle {
    padding: 10px 12px;
    font-size: 12.5px;
    color: #475569;
    background: #f8f9fb;
}

.mr-group-toggle-left,
.mr-subgroup-toggle-left {
    flex: 1;
    min-width: 0;
}

.mr-group-count {
    flex-shrink: 0;
    min-width: 22px;
    text-align: center;
    padding: 1px 8px;
    border-radius: 20px;
    background: #eef2ff;
    color: #1a418c;
    font-size: 11px;
    font-weight: 800;
}

.mr-group-toggle > ion-icon:last-child,
.mr-subgroup-toggle > ion-icon:last-child {
    flex-shrink: 0;
    font-size: 15px;
    color: #adb5bd;
}

.mr-group-body {
    border-top: 1px solid #eef0f5;
    padding: 10px;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.mr-group-body-nested {
    padding: 8px;
    gap: 8px;
    background: #fbfbfd;
}

.mr-subgroup {
    background: #fff;
    border: 1px solid #eef0f5;
    border-radius: 10px;
    overflow: hidden;
}

.mr-status-card-nested {
    box-shadow: none;
    border: 1px solid #eef0f5;
}


.edit-btn {
    margin-left: 8px;
}

.progress {
    width: 80px;
}

.listview>li footer {
    color: #171617;
}

.min-width-50 {
    min-width: 60% !important;
}

.action-button-list>li {
    min-height: 1px !important;
}

.sl-no {
    font-weight: 900;
    margin-right: 12px;
}

.deleted-list-title {
    font-size: 15px;
}

.deleted-list {
    margin-bottom: 20px;
}

.deleted-info {
    background-color: #f2bbca;
    font-size: 12px;
}

.deleted-info strong {
    font-size: 18px;
    font-weight: 600;
}

.image-listview.text>li:after {
    left: 0px;
    /* height: 1px; */
    background-color: #1a418c;
}

.verification-badge {
    margin-left: 5px;
}

.avatar-section .button {
    color: #fff;
    width: 18px;
    height: 18px;
    border-radius: 100%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    position: absolute;
    right: 10px;
    top: 24px;
    bottom: 0;
}

.avatar-section .verified {
    background: #4dc81c;
}

.avatar-section .not-verified {
    background: #eb3941;
}

.wallet-card .wallet-footer .item .icon-wrapper {
    width: 100%;
    height: 48px;
    display: inline-flex;
    align-items: left;
    justify-content: left;
    border-radius: 10px;
    color: #fff;
    /* font-size: 28px; */
    margin-bottom: 14px;
    padding-left: 10px;
}

.wallet-card {
    padding-bottom: 0px !important;

}

.menu-title {
    color: #fff !important;
    font-size: 12px !important;
    padding-left: 5px !important;
    text-align: left !important;
}

.wallet-card .balance .total {
    font-weight: 700;
    letter-spacing: -0.01em;
    line-height: 1em;
    font-size: 26px;
}

.wallet-card .balance .title {
    color: #27173E;
    font-weight: 500;
    font-size: 16px !important;
    display: block;
    margin-bottom: 8px;
}

.stat-box {
    background: #ffffff;
    box-shadow: 0 1px 3px 0 rgb(0 0 0 / 9%);
    border-radius: 10px;
    padding: 10px 10px;
}

.wallet-card .balance {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    height: auto;
}

.left {
    margin-left: 0px;
}

.wallet-card {
    background: #ffffff;
    box-shadow: 0 1px 3px 0 rgb(0 0 0 / 9%);
    border-radius: 10px;
    padding: 0px 10px;
    position: relative;
    z-index: 1;
}
.badge {
    border-radius: 0px !important;
}
.back-color-primary{
    background: #1a418c !important;
}

.back-color-secondary{
    background: #666d79 !important;
}
.back-color-danger{
    background: #de6f56 !important;
}
.back-color-warning{
    background: #b19547 !important;
}
.back-color-red{
    background: #d55454  !important;
}

.back-color-violet{
    background: #0000A3  !important;
}

.back-color-blue1{
    background: #0000D1  !important;
}
.back-color-blue2{
    background: #0000FF  !important;
}
.back-color-blue3{
    background: #2E2EFF  !important;
}
.back-color-blue4{
    background: #5C5CFF  !important;
}
.back-color-blue5{
    background: #8A8AFF  !important;
}
.back-color-blue6{
    background: #8F00FF  !important;
}

/* Classic Report Table Styles */
.report-container {
    background: #ffffff;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
}

.table-classic {
    width: 100%;
    border-collapse: collapse;
    background: #ffffff;
    font-size: 14px;
}

.table-classic thead {
    background: #f8f9fa;
    border-bottom: 2px solid #dee2e6;
}

.table-classic thead th {
    padding: 14px 16px;
    text-align: left;
    font-weight: 600;
    color: #27173E;
    border-bottom: 2px solid #dee2e6;
    font-size: 13px;
    line-height: 1.4;
}

.table-classic thead th.col-name {
    text-align: left;
    padding-left: 20px;
}

.table-classic thead th.col-status {
    text-align: center;
}

.table-classic thead th.col-attendance {
    text-align: right;
    padding-right: 20px;
}

.header-multiline {
    line-height: 1.5;
}

.table-classic tbody tr.report-row {
    border-bottom: 1px solid #e9ecef;
    transition: background-color 0.2s ease;
}

.table-classic tbody tr.report-row:hover {
    background-color: #f8f9fa;
}

.table-classic tbody tr.report-row:last-child {
    border-bottom: none;
}

.table-classic tbody td {
    padding: 16px;
    vertical-align: top;
    color: #495057;
}

.table-classic .cell-name {
    text-align: left;
    padding-left: 20px;
    font-weight: 600;
    color: #27173E;
    min-width: 150px;
}

.table-classic .cell-name .name-link a,
.table-classic .cell-name .name-text {
    color: #1a418c;
    text-decoration: none;
    font-weight: 600;
    font-size: 14px;
}

.table-classic .cell-name .name-link a:hover {
    text-decoration: underline;
    color: #0d2b5c;
}

.table-classic .cell-status {
    text-align: left;
    padding: 16px 12px;
}

.status-content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
}

.status-content span {
    display: block;
    font-size: 13px;
    color: #495057;
}

.meeting-date-badge {
    display: inline-block;
    padding: 3px 8px;
    background: rgba(17, 24, 39, 0.06);
    color: #374151;
    border: 1px solid #e5e7eb;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 600;
    margin-top: 2px;
}

.table-classic .cell-attendance {
    text-align: right;
    padding-right: 20px;
    padding-left: 16px;
}

.attendance-list {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 6px;
}

.attendance-item {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 10px;
    font-size: 13px;
    min-width: 120px;
}

.attendance-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    color: #ffffff;
    font-weight: 600;
    font-size: 11px;
    flex-shrink: 0;
    line-height: 1;
}

.attendance-badge.badge-ws {
    background: #1a418c;
}

.attendance-badge.badge-yt {
    background: #28a745;
}

.attendance-badge.badge-st {
    background: #dc3545;
}

.attendance-badge.badge-wm {
    background: #6c757d;
}

.attendance-badge.badge-gl {
    background: #6c757d;
}

.attendance-value {
    color: #495057;
    font-weight: 500;
    min-width: 70px;
    text-align: right;
    white-space: nowrap;
    font-size: 13px;
}

.attendance-total {
    margin-top: 8px;
    padding-top: 8px;
    border-top: 1px solid #dee2e6;
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 600;
}

.attendance-total .total-label {
    color: #6c757d;
    font-size: 12px;
}

.attendance-total .total-value {
    color: #27173E;
    font-size: 14px;
}

/* Mobile and Desktop View Toggle */
.desktop-view {
    display: block;
}

.mobile-view {
    display: none;
}

/* Mobile Card Styles */
.mobile-view {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.mobile-report-card {
    background: #ffffff;
    border-radius: 10px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    border: 1px solid #e9ecef;
}

.mobile-report-card-clickable {
    cursor: pointer;
    text-decoration: none;
    display: block;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.mobile-report-card-clickable:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.mobile-report-card-clickable:active {
    transform: translateY(0);
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.mobile-report-card-clickable * {
    text-decoration: none;
}

.mobile-card-header {
    background: #f8f9fa;
    padding: 14px 16px;
    border-bottom: 2px solid #dee2e6;
}

.mobile-name {
    font-weight: 600;
    font-size: 15px;
    color: #27173E;
}

.mobile-name .name-text {
    color: #27173E;
    text-decoration: none;
    font-weight: 600;
}

.mobile-report-card-clickable .mobile-name .name-text {
    color: #1a418c;
}

.mobile-report-card-clickable:hover .mobile-name .name-text {
    color: #0d2b5c;
}

.mobile-card-body {
    padding: 16px;
}

.mobile-status-section,
.mobile-attendance-section {
    margin-bottom: 16px;
}

.mobile-status-section:last-child,
.mobile-attendance-section:last-child {
    margin-bottom: 0;
}

.mobile-label {
    font-size: 11px;
    font-weight: 600;
    color: #6c757d;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 8px;
    display: block;
}

.mobile-status-content {
    display: flex;
    flex-direction: column;
    gap: 6px;
    align-items: flex-start;
    display: flex;
    padding: 4px 10px;
}

/* Labeled chips for status */
.status-chips {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
}

.chip {
    display: inline-flex;
    align-items: center;
    padding: 3px 8px;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 600;
    line-height: 1;
}

.chip-decided {
    background: #dbeafe; /* blue-100 */
    color: #1e40af;      /* blue-800 */
    border: 1px solid #bfdbfe; /* blue-200 */
}

.chip-confirmed {
    background: #dcfce7; /* green-100 */
    color: #166534;      /* green-800 */
    border: 1px solid #bbf7d0; /* green-200 */
}

.chip-happened {
    background: #ede9fe; /* violet-100 */
    color: #5b21b6;      /* violet-800 */
    border: 1px solid #ddd6fe; /* violet-200 */
}

.table-meeting-status .cell-status-number {
    text-align: center;
    font-weight: 800;
    font-size: 14px;
    color: #111827;
}

.table-meeting-status .cell-status-number.decided {
    color: #b45309; /* amber-700 */
}

.table-meeting-status .cell-status-number.confirmed {
    color: #1d4ed8; /* blue-700 */
}

.table-meeting-status .cell-status-number.happened {
    color: #15803d; /* green-700 */
}

.table-meeting-status thead th {
    padding-top: 10px;
    padding-bottom: 10px;
    line-height: 1.1;
}

.meeting-status-card {
    border-radius: 10px;
    overflow: hidden;
    border: 1px solid #e9ecef;
}

.meeting-status-table th {
    font-size: 11px;
    text-align: center;
    background-color: #f8f9fa;
    font-weight: 600;
    vertical-align: middle;
    padding: 5px 4px;
    line-height: 1.1;
}

.meeting-status-table td {
    text-align: center;
    font-size: 13px;
    vertical-align: middle;
    padding: 8px 4px;
    line-height: 1.25;
}

.meeting-status-name {
    text-align: left !important;
    white-space: nowrap;
}

.meeting-status-number {
    font-weight: 800;
    font-size: 14px;
}

.meeting-status-number.decided { color: #1e40af; }
.meeting-status-number.decided { color: #b45309; } /* amber-700 */
.meeting-status-number.confirmed { color: #1d4ed8; } /* blue-700 */
.meeting-status-number.happened { color: #15803d; } /* green-700 */

.mobile-status-content span {
    font-size: 13px;
    color: #495057;
    font-weight: bolder;
}

.mobile-attendance-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
    margin-bottom: 12px;
    align-items: stretch;
}

.mobile-attendance-item {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 10px 6px;
    background: #f8f9fa;
    border-radius: 6px;
    min-height: 52px;
    flex-direction: column;
    text-align: center;
}

.mobile-attendance-item .attendance-badge {
    width: 36px;
    height: 36px;
    font-size: 11px;
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
}

.mobile-attendance-item .attendance-value {
    font-size: 12px;
    font-weight: 500;
    color: #495057;
    white-space: nowrap;
    width: 100%;
    text-align: center;
    line-height: 1.2;
}

.mobile-attendance-total {
    margin-top: 12px;
    padding-top: 12px;
    border-top: 2px solid #dee2e6;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: 600;
    padding-bottom: 4px;
}

.mobile-attendance-total .total-label {
    color: #6c757d;
    font-size: 13px;
}

.mobile-attendance-total .total-value {
    color: #27173E;
    font-size: 16px;
}

/* Responsive adjustments */
@media (max-width: 768px) {
    .desktop-view {
        display: none !important;
    }
    
    .mobile-view {
        display: flex !important;
    }
    
    .mobile-attendance-grid {
        grid-template-columns: repeat(3, 1fr);
        gap: 8px;
    }
    
    .mobile-attendance-item {
        padding: 10px 6px;
        min-height: 52px;
        gap: 6px;
    }
    
    .mobile-attendance-item .attendance-badge {
        width: 32px;
        height: 32px;
        font-size: 10px;
    }
    
    .mobile-attendance-item .attendance-value {
        font-size: 11px;
    }
}

@media (max-width: 480px) {
    .mobile-card-header {
        padding: 12px 14px;
    }
    
    .mobile-card-body {
        padding: 14px;
    }
    
    .mobile-attendance-grid {
        grid-template-columns: repeat(3, 1fr);
        gap: 6px;
    }
    
    .mobile-attendance-item {
        padding: 8px 4px;
        min-height: 50px;
        gap: 5px;
    }
    
    .mobile-attendance-item .attendance-badge {
        width: 30px;
        height: 30px;
        font-size: 9px;
    }
    
    .mobile-attendance-item .attendance-value {
        font-size: 10px;
    }
    
    .mobile-name {
        font-size: 14px;
    }
    
    .mobile-label {
        font-size: 10px;
    }
    
    .mobile-status-content span {
        font-size: 12px;
    }
}

@media (max-width: 576px) {
    .meeting-status-table th,
    .meeting-status-table td {
        font-size: 11px;
        padding: 5px 2px;
    }

    .meeting-status-number {
        font-size: 14px;
    }
}

@media (max-width: 420px) {
    .meeting-status-table th,
    .meeting-status-table td {
        font-size: 10px;
        padding: 4px 2px;
    }

    .meeting-status-number {
        font-size: 13px;
    }
}
</style>